import React from 'react';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { multiFactor } from 'firebase/auth';

import { useAuth } from '../../../../hooks/useAuth';
import { getNextMFAFactorIdNeedingSetup } from '../../utils';
import { useMFASetupPageContext } from './useMFASetupPageContext';

/**
 * @param {Object} props
 * @param {import('firebase/auth').User} props.user
 * @param {boolean} [props.disabled]
 * @param {import('@mui/system').SystemStyleObject} [props.sx]
 */
export const CancelButton = ({ user, disabled = false, sx }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userType } = useAuth();
  const { method } = useMFASetupPageContext();

  const nextMFAFactorIdNeedingSetup = getNextMFAFactorIdNeedingSetup({ userType, multiFactorUser: multiFactor(user) });

  if (nextMFAFactorIdNeedingSetup === method) {
    return null;
  }

  const isFromSecurityDialog = new URLSearchParams(location.search).get('from') === 'securityUpgradeDialog';

  const handleCancel = () => {
    if (isFromSecurityDialog) {
      navigate(-1);

      return;
    }

    navigate('/account-details/security');
  };

  return (
    <Button disabled={disabled} type="button" variant="outlined" onClick={handleCancel} sx={sx}>
      Cancel
    </Button>
  );
};
